// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import { getCountingBundleRunningAvailability, getCountingBundleTotalAvailability } from './repositories';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import CountingBundleRunningAvailabilityTable from './components/counting-bundle-running-availability-table';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../../shared/services/common-functions';
import { getLastWeeks } from '../../../common/repositories';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class CountingBundleTotalRunningAvailability extends Component {

    state = {
        lastWeeks: [],
        selectedLastWeek: '',
        results: []
    };

    componentDidMount = () => {

        this.props.increaseCounter();
        getLastWeeks().then( response => {

            this.setState( {
                lastWeeks: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleWeekChange ( val ) {

        this.setState( {
            selectedLastWeek: val
        }, () => {

            this.refresh();

        } );

    }

    refresh () {

        if ( this.state.selectedLastWeek ) {

            this.props.increaseCounter();

            const selectedLastWeekVal = this.state.lastWeeks
                .find( lastweekObj => Number( lastweekObj.weekEnding ) ===
                Number( this.state.selectedLastWeek ) )
                .weekNumber;

            const funcName = this.props.bundleAvailability === true ?
                getCountingBundleRunningAvailability : getCountingBundleTotalAvailability;
            funcName( selectedLastWeekVal )
                .then( response => {

                    this.setState( {
                        results: response
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const { bundleAvailability } = this.props;

        const { selectedLastWeek, lastWeeks, results } = this.state;

        const pageHeading = bundleAvailability === true ? 'Counting Bundle Running Availability' : 'Counting Bundle Total Availability';

        function buildLastWeekDate ( dateVal ) {

            const formattedVal = formatGivenDate( dateVal, 'YYYY-MM-DD' );
            if ( formattedVal === '2000-01-01' ) {

                return 'Inventory';

            } if ( formattedVal === '2000-02-01' ) {

                return 'Rework';

            }
            return formattedVal;

        }
        const lastWeekDates = lastWeeks ? lastWeeks.map( date => ( {
            label: buildLastWeekDate( date.weekEnding ), id: date.weekEnding
        } ) ) : [];

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">{pageHeading}</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-counting-bundle-running-availability-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-counting-bundle-running-availability-select"
                                    label="Last Week"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleWeekChange.bind( this )}
                                    optionDisplayAttributes={['label']}
                                    optionKey="id"
                                    options={lastWeekDates}
                                    placeholder="Select Week"
                                    selectedValue={selectedLastWeek}
                                    isRequired={false}
                                />

                                {selectedLastWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        {results !== null && results.length > 0 && selectedLastWeek && (
                            <CountingBundleRunningAvailabilityTable
                                results={results}
                                unitCode={this.props.unit.name}
                                selectedLastWeek={selectedLastWeek}
                                lastWeeks={lastWeeks}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

CountingBundleTotalRunningAvailability.displayName = 'CountingBundleTotalRunningAvailability';
CountingBundleTotalRunningAvailability.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object,
    bundleAvailability: PropTypes.bool
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( CountingBundleTotalRunningAvailability ) );
